export default __webpack_public_path__ + "locales/lo-LA/Settings.json?hash=938f86ef1429555e67e43bd4b776c52a";